export enum CopySectionMaskEnum {
	PHONE = 'phone',
	PHONE_WITHOUT_DDD = 'phone-without-ddd',
	LONG_PHONE = 'long-phone',
	WITHOUT_MASK = 'without-mask',
	CLEAR = 'clear',
}
